import _ from "underscore";
import UserSelectorTreeBuilder from "./builder/UserSelectorTreeBuilder";
import {stringComparator} from "../atUtils";
import HideUserGroupsStrategy from "./userSelectorGroupsStrategies/HideUserGroupsStrategy";
import ShowUserGroupsStrategy from "./userSelectorGroupsStrategies/ShowUserGroupsStrategy";

/**
 * Compare two User objects
 * @param a first user
 * @param b second user
 */
export function userComparator( a, b )
{
    var result = stringComparator( a.lastName, b.lastName );
    if( result === 0 )
    {
        result = stringComparator( a.firstName, b.firstName );
        if( result === 0 )
        {
            // empty string = false is ok there
            result = stringComparator(a.middleName || "", b.middleName || "");
            if( result === 0 )
            {
                result = stringComparator( a.username || "", b.username || "");
            }
        }
    }
    return result;
}

function buildUserSelectorTreeWithGroupsData( users, groupsData, rootNode, observer, filter, getGroupIdFromUserCallback )
{
    if (filter)
        users = _.filter(users, function(user) { return filter.matches(user); });

    var treeBuilder = new UserSelectorTreeBuilder(
            rootNode,
            users,
            groupsData ? groupsData.map : null,
            groupsData ? groupsData.order : null,
            observer,
            getGroupIdFromUserCallback);
    treeBuilder.buildTree();
}

export function buildUserSelectorTreeWithUserGroupsData( users, userGroupsData, rootNode, observer, filter )
{
    buildUserSelectorTreeWithGroupsData(users, userGroupsData, rootNode, observer, filter,
                                        function( user ) { return user.userGroupId; });
}

export function buildUserSelectorTreeWithTimeZoneGroupsData( users, timeZoneGroupsData, rootNode, observer, filter )
{
    buildUserSelectorTreeWithGroupsData(users, timeZoneGroupsData, rootNode, observer, filter,
                                        function( user ) { return user.timeZoneGroupId });
}

export function getUserSelectorFeatureStrategy()
{
    return window.EnabledFeatures.TZG || window.EnabledFeatures.UGR  ? new ShowUserGroupsStrategy() : new HideUserGroupsStrategy();
}


// WEBPACK FOOTER //
// ./web/js/usersSelector/user_group_selector_util.js